var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40406 6.1192L8.68977 3.83349C8.91294 3.61033 8.91294 3.24852 8.68977 3.02536L6.40406 0.73965C6.24063 0.576222 5.99486 0.527333 5.78133 0.61578C5.56779 0.704226 5.42857 0.912589 5.42857 1.14371V2.57228L3.14286 2.57229C1.40711 2.57229 0 3.97939 0 5.71515V10.2866C0 12.0223 1.40711 13.4294 3.14286 13.4294H4.28571C4.7591 13.4294 5.14286 13.0456 5.14286 12.5723C5.14286 12.0989 4.7591 11.7151 4.28571 11.7151H3.14286C2.35387 11.7151 1.71429 11.0755 1.71429 10.2866V5.71515C1.71429 4.92616 2.35387 4.28657 3.14286 4.28657L5.42857 4.28656V5.71513C5.42857 5.94627 5.56779 6.15462 5.78133 6.24306C5.99486 6.33152 6.24063 6.28263 6.40406 6.1192ZM10.5714 14.858V13.4294H12.8571C14.5929 13.4294 16 12.0223 16 10.2866V5.71513C16 3.97939 14.5929 2.57228 12.8571 2.57228H11.7143C11.2409 2.57228 10.8571 2.95604 10.8571 3.42942C10.8571 3.90281 11.2409 4.28656 11.7143 4.28656H12.8571C13.6462 4.28656 14.2857 4.92616 14.2857 5.71513V10.2866C14.2857 11.0755 13.6462 11.7151 12.8571 11.7151H10.5714V10.2866C10.5714 10.0554 10.4322 9.84709 10.2187 9.75863C10.0051 9.67019 9.75937 9.71908 9.59594 9.8825L7.31023 12.1683C7.08706 12.3913 7.08706 12.7532 7.31023 12.9764L9.59594 15.2621C9.75937 15.4255 10.0051 15.4743 10.2187 15.386C10.4322 15.2975 10.5714 15.0891 10.5714 14.858Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopIcon);
export default __webpack_public_path__ + "static/media/loopIcon.19da9c7d81fe260cc0f5e0e656d8483f.svg";
export { ForwardRef as ReactComponent };